import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { print } from "graphql/language/printer";
import gql from "graphql-tag";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// Define a type for the slice state
interface AppState {
  init: boolean;
  process: any;
  location: {
    hostname: string;
    search: any;
    pathname: string;
  };
}

// Define the initial state using that type
const initialState: AppState = {
  init: false,
  process: process.env,
  location: {
    hostname: window.location.hostname,
    search: window.location.search,
    pathname: window.location.pathname,
  },
};

// const fetchUserById = createAsyncThunk(
//   "app/setInit",
//   async (init, thunkAPI) => {
//     return init;
//   }
// );

export const appSlice = createSlice({
  name: "app",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setInit: (state, action: PayloadAction<boolean>) => {
      state.init = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   // Add reducers for additional action types here, and handle loading state as needed
  //   builder.addCase(fetchUserById.fulfilled, (state, action) => {
  //     state.entities.push(action.payload)
  //   })
});

// export const appApi = createApi({
//   reducerPath: "app-api",
//   baseQuery: fetchBaseQuery({
//     baseUrl: process.env.REACT_APP_GRAPHQL_API_URL,
//     prepareHeaders: (headers, { getState }) => {
//       headers.set("x-api-key", process.env.REACT_APP_GRAPHQL_API_KEY!);
//       return headers;
//     },
//   }),
//   endpoints: (builder) => ({
//     getNavigation: builder.query<any, { id: string }>({
//       query: (post) => {
//         return {
//           url: "",
//           method: "POST",
//           body: {
//             query: print(gql`
//               query GET_NAVIGATION_QUERY($id: ID!) {
//                 getPod(id: $id) {
//                   id
//                   join {
//                     id
//                     pods {
//                       items {
//                         id
//                         name
//                         pods {
//                           items {
//                             id
//                             name
//                             joinID
//                             schemaID
//                           }
//                         }
//                         schemaID
//                       }
//                     }
//                   }
//                 }
//               }
//             `),
//             variables: {
//               id: post.id,
//             },
//           },
//         };
//       },
//       transformResponse: (response: any) => {
//         return response.data;
//       },
//     }),
//   }),
// });

// // Export hooks for usage in functional components, which are
// // auto-generated based on the defined endpoints
// export const { useGetNavigationQuery } = appApi;

export const { setInit } = appSlice.actions;

// Other code such as selectors can use the imported `RootState` type
//export const selectCount = (state: RootState) => state.counter.value;

export default appSlice.reducer;
